/**
 *  @class
 *  @function CustomPickup
 * TODO:
 * - Deploy and test without the other component. 
 */
if (!customElements.get("custom-pickup")) {
  customElements.define(
    "custom-pickup",
    class CustomPickup extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          shippingButton: this.querySelector("button.shipping-button"),
          pickupButton: this.querySelector("button.pickup-button"),
          pickupLocationsPanel: this.querySelector(".pickup-locations-panel"),
          locationSearch: this.querySelector("input.location-search"),
          pickupLocationsList: this.querySelectorAll(
            "input[name='location-list-item']"
          ),
          errorMessage: this.querySelector("div.select-pickup-error"),
          locationsList: this.querySelector("div.locations-list"),
        };

        this.elements.pickupButton.addEventListener(
          "click",
          this.showPickupLocations.bind(this)
        );
        this.elements.shippingButton.addEventListener(
          "click",
          this.hidePickupLocations.bind(this)
        );
        this.elements.locationSearch.addEventListener(
          "input",
          this.filterLocations.bind(this)
        );

        this.elements.pickupLocationsPanel.addEventListener("change", (event) => {
          if (event.target.name === 'location-list-item') {
            if(event.target.value) {
              this.showHideErrorMessage(false);
            }
          }
        })

        // Attach to the main checkout button
        this.checkoutButtons = document.querySelectorAll('[name="checkout"]');
        const lastCheckoutButton = this.checkoutButtons.length > 1 ? this.checkoutButtons[this.checkoutButtons.length - 1] : this.checkoutButtons[0];
        lastCheckoutButton.addEventListener(
          "click",
          this.handleSubmit.bind(this)
        );

        // Check existing cart attributes
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Error getting cart information`);
            }
            return response.json();
          })
          .then((data) => {
            const selectedShippingMethod = data.attributes["Shipping Method"];
            if (selectedShippingMethod && selectedShippingMethod == "Pickup") {
              this.showPickupLocations();
              const selectedPickupLocationId =
                data.attributes["Pickup Depot ID"];
              if (selectedPickupLocationId) {
                this.elements.pickupLocationsList.forEach((element) => {
                  if (element.value == selectedPickupLocationId) {
                    element.checked = true;
                  }
                });
              }
            } else {
              this.hidePickupLocations();
            }
          })
          .catch((error) => {
            console.error("[ERA] ", error);
          });

        // TODO: Handle shipping scenario as well. (If company is depot delete shipping info)
      }

      async handleSubmit(event) {
        const submitButton = event.target;
        event.preventDefault();
        this.showHideErrorMessage(false);

        const isPickupSelected =
          this.elements.pickupButton.classList.contains("active");
        const pickupPlaceholderItem = { id: this.dataset.pickupPlaceholderId };
        var selectedLocation = this.querySelector("input[name='location-list-item']:checked");
        
        // First validate if any of the items are selected.
        if (isPickupSelected == true && !selectedLocation) {
          this.showHideErrorMessage(true);
          event.stopPropagation();
          return;
        }

        submitButton.disabled = true;

        const cartData = await fetch(
          window.Shopify.routes.root + "cart.js"
        ).then((response) => {
          if (!response.ok) {
            throw new Error(`Error getting cart information`);
          }
          return response.json();
        });

        // Delivery is selected
        if (isPickupSelected === false) {
          // Check if the pickp product is in the cart. That means, everything is set in the current cart
          if (
            cartData.items.find((item) => item.id == pickupPlaceholderItem.id)
          ) {
            // Remove pickup product from cart
            pickupPlaceholderItem.quantity = 0;
            await fetch(window.Shopify.routes.root + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(pickupPlaceholderItem),
            });
          }

          // Remove cart attributes
          cartData.attributes["Shipping Method"] = "";
          cartData.attributes["Pickup Depot ID"] = "";
          cartData.attributes["Pickup Depot Company"] = "";
          cartData.attributes["Pickup Depot Address1"] = "";
          cartData.attributes["Pickup Depot City"] = "";
          cartData.attributes["Pickup Depot State"] = "";
          cartData.attributes["Pickup Depot Postcode"] = "";
          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ attributes: cartData.attributes }),
          });

          // Remove shipping information
          const closestFormUrl = submitButton.form.action;
          const cartQuery =
            "checkout[shipping_address][address1]= " +
            "&checkout[shipping_address][city]= " +
            "&checkout[shipping_address][company]= " +
            "&checkout[shipping_address][country]= " +
            "&checkout[shipping_address][province]= " +
            "&checkout[shipping_address][zip]= " +
            "&skip_shopify_pay=false&step=contact_information";
          if (
            closestFormUrl &&
            (closestFormUrl.endsWith("/cart") ||
              closestFormUrl.endsWith("/checkout"))
          ) {
            submitButton.form.action = "/checkout?" + cartQuery;
          }
          submitButton.form.submit();

          return;
        }

        try {
          // Update cart attributes with new location
          const cartAttributes = {
            "Shipping Method": "Pickup",
            "Pickup Depot ID": selectedLocation.value,
            "Pickup Depot Company": selectedLocation.dataset.company,
            "Pickup Depot Address1": selectedLocation.dataset.address1,
            "Pickup Depot City": selectedLocation.dataset.city,
            "Pickup Depot State": selectedLocation.dataset.state,
            "Pickup Depot Postcode": selectedLocation.dataset.postcode,
          };
          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ attributes: cartAttributes }),
          });

          pickupPlaceholderItem["properties"] = {
            "Pickup Depot": selectedLocation.dataset.company,
          };
          // Check if our item here
          const existingPickupPlaceholderItem = cartData.items.find(
            (item) => item.id == pickupPlaceholderItem.id
          );
          if (existingPickupPlaceholderItem) {
            // Update the item properties
            await fetch(window.Shopify.routes.root + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(pickupPlaceholderItem),
            });
          }
          else{
            await fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(pickupPlaceholderItem),
            });
          }

          // Update teh checkout URL with selected pickup location
          this.updateCartPermlink(selectedLocation, submitButton);
        } catch (error) {
          console.error("[ERA]: ", error);
        }
        finally {
          submitButton.form.submit();
        }
      }

      updateCartPermlink(selectedLocation, submitButton) {
        if (!submitButton) {
          return;
        }
        const closestForm = submitButton.form;
        if (!closestForm) {
          return;
        }
        const closestFormUrl = "/checkout"; //closestForm.action;
        const cartQuery =
          "checkout[shipping_address][address1]=" +
          encodeURIComponent(selectedLocation.dataset.address1) +
          "&checkout[shipping_address][address2]=" +
          "&checkout[shipping_address][city]=" +
          encodeURIComponent(selectedLocation.dataset.city) +
          "&checkout[shipping_address][company]=" +
          encodeURIComponent(selectedLocation.dataset.company) +
          "&checkout[shipping_address][country]=" +
          encodeURIComponent(selectedLocation.dataset.country) +
          "&checkout[shipping_address][province]=" +
          encodeURIComponent(selectedLocation.dataset.state) +
          "&checkout[shipping_address][zip]=" +
          encodeURIComponent(selectedLocation.dataset.postcode) +
          "&discount=&locale=en-GP" +
          "&skip_shopify_pay=true&step=contact_information";
        if (
          closestFormUrl &&
          (closestFormUrl.endsWith("/cart") ||
            closestFormUrl.endsWith("/checkout"))
        ) {
          closestForm.action = closestFormUrl + "?" + cartQuery;
        }
      }

      // submitFormManually(form) {
      //   //form.removeEventListener("submit", testValidAgainstServer);
      //   form.submit();
      // }

      showPickupLocations() {
        // TODO: Clear any search text
        this.elements.pickupLocationsPanel.style.display = "block";
        this.elements.pickupButton.classList.add("active");
        this.elements.shippingButton.classList.remove("active");
      }

      hidePickupLocations() {
        this.elements.pickupLocationsPanel.style.display = "none";
        this.elements.pickupButton.classList.remove("active");
        this.elements.shippingButton.classList.add("active");
      }

      showHideErrorMessage(isShow){
        this.elements.errorMessage.style.display = "none";
        this.elements.locationsList.classList.remove('error');
        if(isShow === true){
          this.elements.errorMessage.style.display = "block";
          this.elements.locationsList.classList.add('error');
        }
      }

      filterLocations(event){
        const query = event.target.value.toLowerCase();
        this.elements.pickupLocationsList.forEach((element) => {
          // Get text from the label specifically
          const text = element.nextElementSibling.innerText.toLowerCase();
      
          // Toggle display: block/none based on match
          if (text.includes(query)) {
            element.parentElement.style.display = 'flex';
          } else {
            element.parentElement.style.display = 'none';
          }
        });
      }
      /////////// STOPPED HERE>
    }
  );
}
